/* tslint:disable */
/* eslint-disable */
/**
 * API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../../common/runtime';
/**
 *
 * @export
 * @interface CampaignPatch
 */
export interface CampaignPatch {
  /**
   * the action to take on the campaign
   * @type {string}
   * @memberof CampaignPatch
   */
  action?: CampaignPatchActionEnum;
  /**
   * optional caller_id in E164 format
   * @type {string | null}
   * @memberof CampaignPatch
   */
  callerId?: string | null;
  /**
   * When this campaign is scheduled to end. None if never ending.
   * @type {Date | null}
   * @memberof CampaignPatch
   */
  dateScheduledEnd?: Date | null;
  /**
   * When this campaign is scheduled to start. None if start immediately.
   * @type {Date | null}
   * @memberof CampaignPatch
   */
  dateScheduledStart?: Date | null;
  /**
   * Description of Campaign
   * @type {string}
   * @memberof CampaignPatch
   */
  description?: string;
  /**
   * the dialpad Target id calls/texts will be associated with
   * @type {number | null}
   * @memberof CampaignPatch
   */
  groupId?: number | null;
  /**
   * If the campaign should dynamically create lead list items from an audience
   * @type {boolean}
   * @memberof CampaignPatch
   */
  isDynamic?: boolean;
  /**
   * Campaign name for display
   * @type {string}
   * @memberof CampaignPatch
   */
  name?: string;
  /**
   * settings related to campaign
   * @type {string | null}
   * @memberof CampaignPatch
   */
  settings?: string | null;
  /**
   * Dialing strategy for the campaign
   * @type {string}
   * @memberof CampaignPatch
   */
  strategy?: CampaignPatchStrategyEnum;
}

/**
 * @export
 */
export const CampaignPatchActionEnum = {
  Launch: 'launch',
  Ping: 'ping',
  Toggle: 'toggle',
  Start: 'start',
  Stop: 'stop',
  Reset: 'reset',
  Pause: 'pause',
  Archive: 'archive',
  Unarchive: 'unarchive',
} as const;
export type CampaignPatchActionEnum =
  (typeof CampaignPatchActionEnum)[keyof typeof CampaignPatchActionEnum];

/**
 * @export
 */
export const CampaignPatchStrategyEnum = {
  Progressive: 'progressive',
  Predictive: 'predictive',
  Preview: 'preview',
} as const;
export type CampaignPatchStrategyEnum =
  (typeof CampaignPatchStrategyEnum)[keyof typeof CampaignPatchStrategyEnum];

/**
 * Check if a given object implements the CampaignPatch interface.
 */
export function instanceOfCampaignPatch(value: object): value is CampaignPatch {
  return true;
}

export function CampaignPatchFromJSON(json: any): CampaignPatch {
  return CampaignPatchFromJSONTyped(json, false);
}

export function CampaignPatchFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): CampaignPatch {
  if (json == null) {
    return json;
  }
  return {
    action: json['action'] == null ? undefined : json['action'],
    callerId: json['caller_id'] == null ? undefined : json['caller_id'],
    dateScheduledEnd:
      json['date_scheduled_end'] == null
        ? undefined
        : new Date(json['date_scheduled_end']),
    dateScheduledStart:
      json['date_scheduled_start'] == null
        ? undefined
        : new Date(json['date_scheduled_start']),
    description: json['description'] == null ? undefined : json['description'],
    groupId: json['group_id'] == null ? undefined : json['group_id'],
    isDynamic: json['is_dynamic'] == null ? undefined : json['is_dynamic'],
    name: json['name'] == null ? undefined : json['name'],
    settings: json['settings'] == null ? undefined : json['settings'],
    strategy: json['strategy'] == null ? undefined : json['strategy'],
  };
}

export function CampaignPatchToJSON(value?: CampaignPatch | null): any {
  if (value == null) {
    return value;
  }
  return {
    action: value['action'],
    caller_id: value['callerId'],
    date_scheduled_end:
      value['dateScheduledEnd'] == null
        ? value['dateScheduledEnd']
        : (value['dateScheduledEnd'] as any).toISOString(),
    date_scheduled_start:
      value['dateScheduledStart'] == null
        ? value['dateScheduledStart']
        : (value['dateScheduledStart'] as any).toISOString(),
    description: value['description'],
    group_id: value['groupId'],
    is_dynamic: value['isDynamic'],
    name: value['name'],
    settings: value['settings'],
    strategy: value['strategy'],
  };
}
